import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useFieldAttributes } from "../../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../../../ui/field-description/field-description-wut.js";
import { FieldErrorWUT } from "../../../ui/field-error/field-error-wut.js";
import { FieldLabelWUT } from "../../../ui/field-label/field-label-wut.js";
import { Widget } from "../../../ui/widget/widget.js";
import { TimeField } from "../../../ui/time-field/time-field.js";
const TimeInputWUT = ({
  id,
  disabled,
  readOnly,
  hidePlaceholder,
  value,
  use24HourFormat,
  onChange,
  onBlur,
  onFocus,
  description,
  target,
  error,
  hasError = false,
  errorMessage,
  required,
  label,
  hideLabel,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  FieldLayout,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        TimeField,
        {
          disabled,
          readOnly,
          id,
          hidePlaceholder,
          required,
          value: value ?? void 0,
          use24HourFormat,
          onChange,
          onBlur,
          onFocus,
          inputId,
          error: hasError,
          ariaLabelledBy: labelId,
          ariaDescribedBy
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  TimeInputWUT
};
//# sourceMappingURL=time-input-wut.js.map
